export const sharedBasketQueryKeys = {
  // One basket, by token.
  byToken: (token: string) => ['shared-basket', token] as const,
  // Every link the signed-in user has created.
  mine: ['shared-baskets', 'mine'] as const,
} as const;
